class CustomMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.data = JSON.parse(this.dataset?.navJson) ?? false;
    document.querySelector('.custom-mega-menu__dropdown').style.display = 'none';
    document.querySelector('.menu-drawer__navigation').style.display = 'none';
    if(document.querySelector('.menu-drawer__navigation').style.display == 'none' && document.querySelector('.custom-mega-menu__dropdown').style.display == 'none'){
       setTimeout(() =>{
         this.build(this.data);
    }, 0);
    }

   
  }

  async build(L1s) {
    Object.keys(L1s).forEach(L1 => {
        const currentL1 = L1s[L1];
        const L1Link = currentL1.filter(obj => obj.type == 'L1 Link')?.[0].link;
        const L1DesktopMenu = this.querySelector('.header__inline-menu');
        const L1DesktopDropdown = document.querySelector('.custom-mega-menu__dropdown');

        const L1MobileMenu = this.querySelector('.menu-drawer__menu');

        if(L1DesktopMenu){
            L1DesktopMenu.innerHTML += `<a class="custom-mega-menu__l1" href="${L1Link}" >${L1}</a>`;

            if(currentL1.length > 1){
                L1DesktopMenu.querySelector(`[href="${L1Link}"]`).setAttribute('aria-haspopup', 'true');
                L1DesktopMenu.querySelector(`[href="${L1Link}"]`).setAttribute('dropdown-trigger', L1);

                L1DesktopDropdown.innerHTML += `<div class="" data-dropdown="${L1}"></div>`;
                
                for(let i = 1; i <6; i++){
                        const currentDropdown = document.querySelector(`[data-dropdown="${L1}"]`);
                        currentDropdown.innerHTML += `<div data-column="${i}"></div>`;
                        const currentColumn = currentDropdown.querySelector(`[data-column="${i}"]`);
                        currentL1.filter(obj => obj.column == i).forEach(obj => {
                            if(obj.type == 'Image Card'){
                                currentColumn.innerHTML += `<a href="${obj.link}"><div class="custom-mega-menu__item" data-type="${obj.type}" >
                                <img src="${obj.image}"/><p class="title">${obj.text}</p><p class="caption">${obj.textCaption}</p></div></a>`
                            } else {
                                currentColumn.innerHTML += `<a class="custom-mega-menu__item" data-type="${obj.type}" href="${obj.link}">${obj.text}</a>`
                            }
                            
                        })

                }
            }
        }

        if(L1MobileMenu){
                                // Mobile: toggle L3 groups when L3 Title is clicked
                                this.querySelectorAll('.custom-mega-menu__mobile-drawer').forEach(drawer => {
                                    drawer.querySelectorAll('[data-type="L3 Title"]').forEach(title => {
                                        title.addEventListener('click', (e) => {
                                            e.preventDefault();
                                            const titleText = title.textContent.trim();
                                            title.classList.toggle('active');
                                            drawer.querySelectorAll('[data-l3-parent]').forEach(item => {
                                                if (item.getAttribute('data-l3-parent') === titleText) {
                                                    item.classList.toggle('active');
                                                }
                                            });
                                        });
                                    });
                                });
            L1MobileMenu.innerHTML += `<a class="custom-mega-menu__l1" href="${L1Link}" >${L1}</a>`;


            if(currentL1.length > 1){
                L1MobileMenu.querySelector(`[href="${L1Link}"]`).setAttribute('drawer-trigger', L1);
                this.querySelector('nav').innerHTML += `<div class="custom-mega-menu__mobile-drawer" data-drawer="${L1}"></div>`;
                const L2Drawer = this.querySelector(`[data-drawer="${L1}"]`);

                L2Drawer.innerHTML += `
                <div class="custom-mega-menu__l2-header">
                <button><svg class="icon icon-caret" width="31" height="12" viewBox="0 0 31 12" xmlns="http://www.w3.org/2000/svg">
<path d="M30.5303 6.05328C30.8232 5.76039 30.8232 5.28552 30.5303 4.99262L25.7574 0.219651C25.4645 -0.0732428 24.9896 -0.0732429 24.6967 0.219651C24.4038 0.512544 24.4038 0.987417 24.6967 1.28031L28.9393 5.52295L24.6967 9.76559C24.4038 10.0585 24.4038 10.5334 24.6967 10.8263C24.9896 11.1191 25.4645 11.1191 25.7574 10.8263L30.5303 6.05328ZM0 5.52295L-6.55671e-08 6.27295L30 6.27295L30 5.52295L30 4.77295L6.55671e-08 4.77295L0 5.52295Z" fill="currentColor"></path>
</svg></button><span class="custom-mega-menu__l1-title">${L1}</span></div>`;
                for(let i = 1; i <6; i++){
                        let currentL3 = '';
                        currentL1.filter(obj => obj.column == i).forEach(obj => {

                            let l3Parent = '';
                            if(obj.type == 'Image Card'){
                                L2Drawer.innerHTML += `<a class="custom-mega-menu__image-card-link" href="${obj.link}"><div class="custom-mega-menu__item" data-type="${obj.type}" >
                                <img src="${obj.image}"/><p class="title">${obj.text}</p><p class="caption">${obj.textCaption}</p></div></a>`
                            } else {
                                
                                if(obj.type == 'L3 Title'){
                                    currentL3 = obj.text;
                                }

                                if(obj.type == 'L3 Item'){
                                    l3Parent = `data-l3-parent="${currentL3}"`;
                                }
                                L2Drawer.innerHTML += `<a class="custom-mega-menu__item" ${l3Parent} data-type="${obj.type}" href="${obj.link}">${obj.text}</a>`
                            }
                            
                        })

                }
            }
        }


    });
    await this.initializeEventListeners();
    this.setAttribute('data-loaded', true);
    this.classList.add('active');
    if(document.querySelectorAll('custom-mega-menu[data-loaded="true"]').length == 2){
        setTimeout(() => {
 document.querySelector('.custom-mega-menu__dropdown').style.display = '';
        document.querySelector('.menu-drawer__navigation').style.display = '';
        }, 500)
       
    }

  }

  async initializeEventListeners() {

    const dropdownTriggers = this.querySelectorAll('[dropdown-trigger]');
    dropdownTriggers.forEach(trigger => {
        const dropdownId = trigger.getAttribute('dropdown-trigger');
        const dropdown = document.querySelector(`[data-dropdown="${dropdownId}"]`);
        trigger.addEventListener('mouseenter', () => {
            document.querySelector('.custom-mega-menu__dropdown').classList.add('active');
            dropdown.classList.add('active');
        });
        document.querySelector('.custom-mega-menu__dropdown').addEventListener('mouseleave', () => {
            document.querySelector('.custom-mega-menu__dropdown').classList.remove('active');
            dropdown.classList.remove('active');
        });
    });

        this.querySelectorAll('.custom-mega-menu__l1:not([dropdown-trigger])').forEach(link => {
            link.addEventListener('mouseenter', () => {
                document.querySelector('.custom-mega-menu__dropdown').classList.remove('active');
                document.querySelector('.custom-mega-menu__dropdown [data-dropdown].active')?.classList.remove('active');
            });
        });
        // Mobile drawer open/close behavior (use classes instead of inline styles)
        const mobileMenu = this.querySelector('.menu-drawer__menu');
        if (mobileMenu) mobileMenu.classList.add('active');
        // Open specific drawer when a drawer-trigger is clicked
        this.querySelectorAll('[drawer-trigger]').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const id = trigger.getAttribute('drawer-trigger');
                if (!id) return;
                // hide the main mobile menu and show the matching drawer via classes
                if (mobileMenu) mobileMenu.classList.remove('active');
                // hide all drawers then add active to matching one
                this.querySelectorAll('.custom-mega-menu__mobile-drawer').forEach(d => d.classList.remove('active'));
                const target = this.querySelector(`[data-drawer="${id}"]`);
                if (target) target.classList.add('active');
            });
        });

        // Back button inside L2 header: hide drawer, show main menu
        this.querySelectorAll('.custom-mega-menu__mobile-drawer .custom-mega-menu__l2-header > button').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const drawer = btn.closest('.custom-mega-menu__mobile-drawer');
                if (drawer) drawer.classList.remove('active');
                if (mobileMenu) mobileMenu.classList.add('active');
            });
        });
    }   
}

customElements.define('custom-mega-menu', CustomMegaMenu);
